// extracted by mini-css-extract-plugin
export var Grey = "VideoCallout-module--Grey--06c9d";
export var White = "VideoCallout-module--White--102ba";
export var backgroundOverlap = "VideoCallout-module--background-overlap--87e7f";
export var container = "VideoCallout-module--container--b8490";
export var copy = "VideoCallout-module--copy--c9dd2";
export var floatingCallout = "VideoCallout-module--floating-callout--49708";
export var image = "VideoCallout-module--image--78f97";
export var imageBleed = "VideoCallout-module--image-bleed--f793e";
export var imageLeft = "VideoCallout-module--image-left--4f7bd";
export var modalLauncher = "VideoCallout-module--modal-launcher--4b6e8";
export var rounded = "VideoCallout-module--rounded--625cb";
export var shadow = "VideoCallout-module--shadow--a0bee";
export var subtitle = "VideoCallout-module--subtitle--a18d2";
export var videoPlayer = "VideoCallout-module--video-player--0462b";
export var videoThumbnail = "VideoCallout-module--video-thumbnail--1bc46";
export var wide = "VideoCallout-module--wide--e34de";
export var wrapper = "VideoCallout-module--wrapper--2fec5";